import * as React from 'react'
import { useTranslation } from 'react-i18next'
import './closedLabel.css'

// "Closed" badge for a hotel closed for the season on that stay date (instead of N/A).
export default function AppClosedLabel({ className = '' }) {
    const { t } = useTranslation('common')

    return <span className={`app-closed-label ${className}`}>{t('common:misc.closed')}</span>
}
